export default __webpack_public_path__ + "static/media/edit.3b95a298.svg";